import httpClient from '@/api/httpClient';

const downloadMetrics = params =>
  httpClient.post('/api/adminPanel/statistic/metrics', params, { responseType: 'arraybuffer' });

export { downloadMetrics };
